import { HERO_GENERATION_PARAM_COLLECTION_UPDATE } from '@/components/CharacterGenerator/store/action-types'

export default paramCollection => ({
  type: HERO_GENERATION_PARAM_COLLECTION_UPDATE,
  paramCollection,
})
